/**
 * Subscription Opt-in Modal
 * Shows a modal when a subscription product is added to cart
 */

(function() {
  'use strict';

  // Configuration - will be set from theme settings
  let config = {
    modalTitle: '¡Producto agregado en suscripción!',
    modalDescription: 'Has agregado',
    modalPlanText: 'con un plan de:',
    buttonText: 'Entendido',
    imageSize: '120px',
    enabled: true
  };

  // Initialize configuration from window object if available
  if (window.subscriptionOptInConfig) {
    config = { ...config, ...window.subscriptionOptInConfig };
  }

  // Override fetch to intercept cart additions
  const originalFetch = window.fetch;
  
  window.fetch = async function(resource, options) {
    if (typeof resource === "string" && resource.includes("/cart/add")) {
      // Wait for the response
      const response = await originalFetch(resource, options);
      const data = await response.clone().json();
      // Dispatch custom event
      document.dispatchEvent(new CustomEvent("cart:item-added", { detail: data }));
      return response;
    }
    return originalFetch(resource, options);
  };

  // Listen for cart item added events
  document.addEventListener("cart:item-added", (e) => {
    if (!config.enabled) return;
    
    const product = e.detail;
    // Check if product has selling_plan_allocation
    if (product.selling_plan_allocation) {
      let discount = null;
      const deliveryFrequency = product.selling_plan_allocation.selling_plan.name
      if (product.selling_plan_allocation.selling_plan.price_adjustments[0].value_type === "percentage") {
        discount = product.selling_plan_allocation.selling_plan.price_adjustments[0].value;
      } 
      // Show subscription modal
      showSubscriptionModal(product.product_title, deliveryFrequency, product.featured_image, discount);
    }
  });
  
  // <!-- convert-test:subscription-frontend-discount variant-b START -->
  // Variante B: el badge anuncia el 25% del código PRIMERENTREGA (con icono) y
  // debajo se aclara el 12% recurrente del plan. Se activa solo con la clase
  // que inyecta Convert y con la config que emite main-product.liquid; sin
  // ellas, el modal se arma exactamente igual que antes.
  function abVariantBConfig() {
    const cfg = window.ABSubDiscountB;
    if (!cfg || !cfg.modal) return null;
    if (!document.body.classList.contains('ab-sub-discount-b')) return null;
    return cfg;
  }

  function abBadgeContent(ab, discount) {
    if (!ab) return `${discount}% de descuento`;

    const icon = ab.icons && ab.icons.offer
      ? `<img src="${ab.icons.offer}" alt="" width="24" height="24" style="display: block; width: 24px; height: 24px;">`
      : '';

    return `<span style="display: inline-flex; align-items: center; gap: 6px;">${icon}${ab.modal.badge}</span>`;
  }

  function abNoteMarkup(ab, discount) {
    if (!ab || !ab.modal.note) return '';

    const note = ab.modal.note.replace(/\{savings\}/g, `${discount}%`);

    return `
      <p style="font-size: 12px; width: 100%; margin: 0; padding-bottom: 15px; color: rgb(var(--color-foreground)); opacity: 0.9;">
        ${note}
      </p>
    `;
  }

  // Se anexan al final del atributo `style` que ya trae cada elemento: la
  // última declaración gana, así que sobreescriben sin tocar la variante A
  // (con `ab` en null se anexa cadena vacía y el markup queda igual).
  function abExtraStyle(ab, element) {
    if (!ab) return '';

    return {
      badge: 'padding: 6px 16px 0 16px; margin: 15px 0 4px 0; font-family: var(--font-heading-family);',
      description: 'margin: 0; opacity: 1; line-height: 1.5; letter-spacing: 0;',
      frequency: 'line-height: 1.5;',
    }[element] || '';
  }

  // Lo que necesita media queries no cabe en un atributo `style`, así que la
  // variante B marca el elemento con una clase y el tamaño vive en
  // assets/optimize-product.css. En variante A no emite nada: ni el atributo.
  function abClassAttr(ab, element) {
    return ab ? ' class="ab-sub-b__modal-' + element + '"' : '';
  }
  // <!-- convert-test:subscription-frontend-discount variant-b END -->

  function showSubscriptionModal(productTitle, deliveryFrequency, featuredImage, discount) {
    // <!-- convert-test:subscription-frontend-discount variant-b START -->
    const ab = abVariantBConfig();
    // <!-- convert-test:subscription-frontend-discount variant-b END -->

    // Create modal overlay
    const overlay = document.createElement('div');
    overlay.className = 'subscription-modal-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      z-index: 999;
      background: rgba(var(--color-base-opacity), 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fadeIn 0.3s ease;
    `;
    
    // Create modal content
    const modal = document.createElement('div');
    modal.className = 'subscription-modal-content';
    modal.style.cssText = `
      background: rgb(var(--color-background));
      border-radius: var(--popup-corner-radius);
      padding: 3rem 2rem 2rem;
      max-width: 500px;
      width: 90%;
      text-align: center;
      position: relative;
      box-shadow: var(--popup-shadow-horizontal-offset) var(--popup-shadow-vertical-offset) var(--popup-shadow-blur-radius) rgba(var(--color-shadow), var(--popup-shadow-opacity));
      animation: slideUp 0.3s ease;
    `;
    
    modal.innerHTML = `
      <div style="margin-bottom: 1.5rem;">
        <img 
          src="${featuredImage.url}" 
          alt="${featuredImage.alt || productTitle}"
          style="
            width: ${config.imageSize}; 
            height: ${config.imageSize}; 
            object-fit: cover; 
            border-radius: var(--media-radius);
            margin: 0 auto;
            display: block;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          "
        />
      </div>
      <h2 style="font-size: 2rem; margin: 1rem; color: rgb(var(--color-foreground));">
        ${config.modalTitle}
      </h2>
      ${discount ? `
        <div style="display: flex; justify-content: center; align-items: center;">
          <p${abClassAttr(ab, 'badge')} style="font-size: 1.6rem; margin: 1rem; color: rgb(var(--color-foreground)); border-radius: 50px; padding: 2px 16px; background: #c5f7da;${abExtraStyle(ab, 'badge')}">
          ${abBadgeContent(ab, discount)}
          </p>
        </div>
        ${abNoteMarkup(ab, discount)}
      ` : ''}
      <p style="font-size: 1.6rem; margin: 0.5rem; color: rgb(var(--color-foreground)); opacity: 0.9;${abExtraStyle(ab, 'description')}">
        ${config.modalDescription} <strong>${productTitle}</strong> ${config.modalPlanText}
      </p>
      <p style="font-size: 1.8rem; margin: 0.5rem; color: rgb(var(--color-base-accent-1)); font-weight: bold;${abExtraStyle(ab, 'frequency')}">
        ${deliveryFrequency}
      </p>
      <button 
        id="subscription-modal-accept"
        class="button button--full-width"
        style="margin: 0; margin-top: 2rem;"
      >
        ${config.buttonText}
      </button>
    `;
    
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    
    // Add fade in animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes slideUp {
        from { 
          opacity: 0;
          transform: translateY(20px); 
        }
        to { 
          opacity: 1;
          transform: translateY(0); 
        }
      }
    `;
    document.head.appendChild(style);
    
    // Close modal on button click
    document.getElementById('subscription-modal-accept').addEventListener('click', () => {
      overlay.style.animation = 'fadeOut 0.3s ease';
      modal.style.animation = 'slideDown 0.3s ease';
      
      const fadeOutStyle = document.createElement('style');
      fadeOutStyle.textContent = `
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        @keyframes slideDown {
          from { 
            opacity: 1;
            transform: translateY(0); 
          }
          to { 
            opacity: 0;
            transform: translateY(20px); 
          }
        }
      `;
      document.head.appendChild(fadeOutStyle);
      
      setTimeout(() => {
        document.body.removeChild(overlay);
      }, 300);
    });
    
    // Close modal on overlay click
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        document.getElementById('subscription-modal-accept').click();
      }
    });
  }

})();
